/**
 * clientjs service, a small wrapper for ClientJS
 */

const service = new window.ClientJS();
export default service;
